import { createSelector } from 'reselect'

import { getNotificationsByAssociationId } from './notifications';

const sort = files => files.sort((f1, f2) => new Date(f2.created_at).getTime() - new Date(f1.created_at).getTime());

const getFile = (files, id) => files.find(file => file.id === id);
export const makeGetFile = () => createSelector(getFile, file => file);

const getActiveProjectFiles = (files, projectId, notifications = []) => files
    .filter(file => !file.removed && file.project === projectId)
    .sort((f1, f2) => {
        if (!f1) return 1;
        if (!f2) return -1;

        const f1Notifications = !notifications.length ? 0 : getNotificationsByAssociationId(notifications, f1.id).length;
        const f2Notifications = !notifications.length ? 0 : getNotificationsByAssociationId(notifications, f2.id).length;

        if (f1Notifications > f2Notifications) return -1;
        if (f1Notifications < f2Notifications) return 1;

        return new Date(f2.created_at).getTime() - new Date(f1.created_at).getTime();
    });
export const makeGetActiveProjectFiles = () => createSelector(getActiveProjectFiles, files => files);

const getActiveProjectUserFiles = (files, projectId, userId) => sort(files.filter(file => !file.removed && file.project === projectId && file.uploader === userId));
export const makeGetActiveProjectUserFiles = () => createSelector(getActiveProjectUserFiles, files => files);

const getActiveConversationUserFiles = (files, userId) => sort(files.filter(file => !file.removed && !file.project && file.uploader === userId));
export const makeGetActiveConversationUserFiles = () => createSelector(getActiveConversationUserFiles, files => files);

const getActiveUserFiles = (files, userId) => sort(files.filter(file => !file.removed && file.uploader === userId));
export const makeGetActiveUserFiles = () => createSelector(getActiveUserFiles, files => files);

const getUploadingFiles = files => files.filter(file => !file.uploaded || new Date() - new Date(file.uploaded) < 3000);
export const makeGetUploadingFiles = () => createSelector(getUploadingFiles, files => files);

const getProcessingFiles = files => files;
export const makeGetProcessingFiles = () => createSelector(getProcessingFiles, files => files);

const getProjectsFromFiles = files => [...new Set(files.map(file => file.project))];
export const makeGetProjectsFromFiles = () => createSelector(getProjectsFromFiles, projects => projects);
